import { Link } from 'react-router-dom'
import { FaRegUserCircle } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { useMsal } from '@azure/msal-react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/Store'
import { FF_SESSION_KEY } from '../../../utils/constants/apiConstants'

const UserProfile = () => {
  const appUrl = `${document.location.protocol}//${document.location.host}/`
  const { instance, accounts } = useMsal()
  const idToken = useSelector((state: RootState) => state?.atlas?.idToken)
  const user = useSelector((state: RootState) => state?.atlas?.user)
  const authorizedUser = useSelector(
    (state: RootState) => state?.atlas?.authorizedUser,
  )
  // SSO: name comes from MSAL account (user.name)
  // Firefighter: name comes from /Login response (authorizedUser.userName)
  const hasFFSession = !!localStorage.getItem(FF_SESSION_KEY)
  const displayName = hasFFSession ? authorizedUser?.userName : user?.name
  const { t } = useTranslation(['translation'])
  const logoutUrl = `${appUrl}token`
  const logout = () => {
    const hasFFSession = !!localStorage.getItem(FF_SESSION_KEY)
    localStorage.removeItem(FF_SESSION_KEY)
    if (hasFFSession) {
      // Firefighter path — no MSAL session, redirect back to firefighter login
      // Use .replace() so the URL is not added to browser history (prevents Back after logout)
      window.location.replace(`${window.location.origin}/firefighter`)
      return
    }
    const logoutRequest = {
      account: accounts[0],
      postLogoutRedirectUri: logoutUrl,
      idTokenHint: idToken,
    }
    instance.logoutRedirect(logoutRequest)
  }

  return (
    <NavDropdown
      title=<span className="px-1 nav-profile-name ">
        <FaRegUserCircle size={25} />
        <span
          className="px-1"
          style={{ fontSize: 'var(--font-size-extra-large)' }}
        >
          {displayName}
        </span>
      </span>
      id="userProfile"
    >
      <NavDropdown.Item to="/profile" as={Link}>
        {t('userRoles.userprofile')}
      </NavDropdown.Item>
      <NavDropdown.Item onClick={logout}>
        {t('common.sign_out')}
      </NavDropdown.Item>
    </NavDropdown>
  )
}

export default UserProfile
